import { Inventory, Quiz } from '@components/Icons';
import { BasePath } from '@constants/Auth';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { AssessmentOutlined, DescriptionOutlined, Group, ImportContactsOutlined, Settings } from '@material-ui/icons';
import { DeviceErrorPage } from '@pages/error/DeviceErrorPage';
import { FeatureNames, MainContent, MainSideMenu, Menu, Menus } from '@swyft/ui';
import { useFeature } from '@utils/config';
import { ReactElement } from 'react';
import { Layout, LayoutProps } from '../models';
import { MainNavMenu } from './MainNavMenu';

export const MainLayout: Layout = ({ children }: LayoutProps): ReactElement => {
  const { enabled: contactFeatureEnabled } = useFeature(FeatureNames.Contact);
  const { enabled: quoteFeatureEnabled } = useFeature(FeatureNames.Quote);
  const { enabled: analyticFeatureEnabled } = useFeature(FeatureNames.Analytics);

  const items: Menus = [
    {
      path: BasePath + '/leads',
      title: `Leads`,
      icon: Group
    },
    {
      path: contactFeatureEnabled ? BasePath + '/contacts' : '',
      title: `Contacts`,
      icon: ImportContactsOutlined
    },
    {
      path: quoteFeatureEnabled ? BasePath + '/quotes' : '',
      title: `Quotes`,
      icon: DescriptionOutlined
    },
    {
      path: BasePath + '/products',
      title: `Products`,
      icon: Inventory
    },
    {
      path: BasePath + '/questionnaires',
      title: `Questionnaires`,
      icon: Quiz
    },
    {
      path: analyticFeatureEnabled ? BasePath + '/analytics-reports' : '',
      title: `Analytics Reports`,
      icon: AssessmentOutlined
    },
    {
      path: BasePath + '/settings',
      title: `Settings`,
      icon: Settings
    }
  ];

  const adminMenu = items.filter((item: Menu) => item.path);

  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));

  if (isMdDown) {
    return <DeviceErrorPage />;
  }

  return (
    <div className='flex w-full h-full overflow-hidden'>
      <MainNavMenu />
      <MainSideMenu items={adminMenu}></MainSideMenu>
      <MainContent>
        <>
          <Box
            mx='auto'
            p={{ xs: 2, lg: 3 }}
            display={'flex'}
            flexDirection={'column'}
            height={'100%'}
            maxWidth={{ xs: 'calc(100% - 70px)' }}
          >
            {children}
          </Box>
        </>
      </MainContent>
    </div>
  );
};
